// Sound captions (§14.4 "Sound captions", §14.5): the audio engine's live caption list ("Crowd:
// OOOH", "Bomb ticking", "Honk!") drawn as subtitle chips beside the dial while the setting is on.
import type { UiDeps } from '../deps';
import { el, setHidden } from '../ui';

const MAX_LINES = 3;

export interface CaptionLayer { readonly el: HTMLElement; update(): void }

export function createCaptions(deps: UiDeps): CaptionLayer {
  const root = el('div', { class: 'captions', attrs: { 'aria-live': 'polite', 'aria-label': 'Sound captions' } });
  let key = '';
  return {
    el: root,
    update() {
      const on = deps.settings().accessibility.captions;
      setHidden(root, !on);
      if (!on) return;
      const now = performance.now();
      const live = deps.services.captions().filter((c) => c.until > now).slice(-MAX_LINES);
      const k = live.map((c) => c.text).join('|');
      if (k === key) return;
      key = k;
      root.replaceChildren(...live.map((c) => el('div', { class: 'cap' }, el('span', { class: 'cap-dot' }), el('span', { text: c.text }))));
    },
  };
}
